import { FavoritesPanelType, KeyContactsPanelType, LinksPanelType } from 'Feature/Slider/Models/Panels';

export const findFavorites = (favorites: string[], sections: IReactNavSection[]): INavigationLink[] => {
  let newFavorites: INavigationLink[] = [];
  for (var i = 0; i < favorites.length; i++) {
    for (var j = 0; j < sections.length; j++) {
      let link: INavigationLink | undefined = sections[j].Links?.find((link) => link.Link?.TargetId == favorites[i]);
      if (link) newFavorites.push(link);
    }
  }

  return newFavorites;
};

export const getPanelLinks = (
  panels: (FavoritesPanelType | KeyContactsPanelType | LinksPanelType)[],
): IReactNavSection[] => {
  let linkSections: IReactNavSection[] = [];
  for (var i = 0; i < panels.length; i++) {
    if (panels[i].sections) linkSections = linkSections.concat(panels[i].sections);
  }
  return linkSections;
};
